<template>
  <div class="wrapper">
    <!-- 1.顶部标题 -->
    <el-row>
      <h3 class="title">
        <div class="block">
          <span>访客黑名单</span>
        </div>
      </h3>
    </el-row>
    <!-- 3.工具栏 -->
    <el-row>
      <div class="table-tool">
        <el-form inline size="small" >
          <!-- 日期时间框 -->
          <el-form-item style="margin-right:10px;">
            <el-date-picker
              v-model="startAndEndTime"
              type="datetimerange"
              unlink-panels
              style="width:360px;"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            ></el-date-picker>
          </el-form-item>
          <!-- 下拉 -->
          <el-form-item style="margin-right:10px;margin-top:-1px;">
            <el-select v-model="selectPlatformIdList" multiple collapse-tags clearable placeholder="请选择渠道">
              <el-option
                v-for="item in platforms"
                :key="item.id"
                :label="item.name"
                :value="item.tag"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-right:10px;margin-top:-1px;" >
            <el-select v-model="creatorIds" multiple collapse-tags clearable placeholder="请选操作人">
                <el-option
                  v-for="item in creators"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id"
                ></el-option>
            </el-select>
          </el-form-item>
          <!-- 搜索内容 -->
          <el-form-item style="margin-right:10px;margin-top:-1px;">
            <el-input
              class="selectInput"
              style="width:250px"
              v-model="searchText"
              placeholder="请输入访客ID"
            >
              <svg slot="suffix" class="icon" @click="searchBlackList" aria-hidden="true">
                <use xlink:href="#iconsearchicon" />
              </svg>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-top:-1px;">
            <el-button type="info" @click="showAddItemDialog" icon="el-icon-plus">新增黑名单</el-button>
          </el-form-item>
          <el-form-item style="margin-top:-1px;">
            <el-button type="info" @click="showImportItemDialog" icon="el-icon-upload2">导入</el-button>
          </el-form-item>
          <el-form-item style="margin-top:-1px;">
            <el-button type="info" @click="exportList" icon="el-icon-download">导出</el-button>
          </el-form-item>
          <el-form-item style="margin-top:-1px;">
            <el-button type="info" @click="batchDelete" icon="el-icon-delete">批量删除</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-scrollbar class="scrollbar-wrap">
    <!-- 3.表格区 -->
    <el-row>
      <el-table style="width:100%;" :data="tableData" ref="blacklistDataTable">
        <el-table-column  type="selection" align="center" width="55"/>
        <el-table-column prop="visitorId" label="访客ID" align="center" :show-overflow-tooltip="true" />
        <el-table-column
          prop="platformName"
          label="所属渠道"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="unbanTime"
          label="解禁时间"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="banMessage"
          label="封禁原因"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="createTime"
          label="加入名单时间"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="realName"
          label="操作人"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column prop="operation" label="操作" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" content="删除" placement="bottom">
              <el-button
                @click="_deleteItem(scope.row)"
                type="text"
              >
                <svg class="icon icon-delete" aria-hidden="true">
                  <use xlink:href="#icontable-delete" />
                </svg>
              </el-button>
            </el-tooltip>

            <el-tooltip class="item" effect="light" v-show="scope.row.sessionId" content="会话记录" placement="bottom">
              <el-button
                @click="showChatHistory(scope.row)"
                type="text"
              >
                <svg class="icon icon-edit" aria-hidden="true">
                  <use xlink:href="#icontable-bianji" />
                </svg>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页栏 -->
      <el-row style="float:right;">
        <el-pagination
          background
          class="pageStyle"
          layout="total, prev, pager, next, jumper"
          :page-size.sync="pageSize"
          :current-page.sync="pageNum"
          :total="total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-row>
    </el-row>
    </el-scrollbar>

        <!-- 1.新增对话框 -->
    <el-dialog width="600px" title="新增黑名单" :visible="addItemDialog" :close-on-click-modal="false" @close="closeAddItemDialog">
      <el-form ref="addItemForm" size="medium" :model="form" label-width="100px">
        <el-form-item label="访客ID" prop="visitorId" >
          <el-input v-model="form.visitorId" maxlength="200" placeholder="请输入访客ID" style="width:90%;"></el-input>
        </el-form-item>
        <el-form-item label="所属渠道" size="medium" prop="platformIds">
          <el-select v-model="form.platformIds" multiple style="width:90%;">
              <el-option
                v-for="item in platforms"
                :key="item.id"
                :label="item.name"
                :value="item.tag"
              ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="解禁时间" size="medium" prop="unbanTime">
            <el-date-picker
              v-model="form.unbanTime"
              type="datetime"
              placeholder="选择解禁时间"
              align="center"
              prefix-icon="aaa"
              style="width:90%;"
              :picker-options="pickerDisabled"
              >
            </el-date-picker>
        </el-form-item>
        <el-form-item class="text-left" label="封禁原因" prop="banMessage">
          <el-input type="textarea" maxlength="200" rows=4 v-model="form.banMessage" style="width:90%;" placeholder="请输入封禁原因"></el-input>
        </el-form-item>
      </el-form>
      <el-row slot="footer" type="flex" justify="center" style="margin-top: -20px">
        <el-button size="medium" @click="closeAddItemDialog">取 消</el-button>
        <el-button type="primary" size="medium" @click="addNewItem">确 定</el-button>
      </el-row>
    </el-dialog>
    <!-- 1.导入对话框 -->
    <el-dialog width="600px" title="导入黑名单" :visible.sync="importItemDialog" :close-on-click-modal="false" @close="closeImportItemDialog">
      <el-form ref="addItemForm" size="medium" :model="importForm" label-width="100px">
        <el-form-item prop="visitorId" >
          <el-upload
            ref="excelUploader"
            class="upload-demo"
            drag
            :action="uploadAddr"
            accept=".xlsx"
            :auto-upload="false"
            :limit=1
            :headers="headers"
            :before-upload="beforeUpload"
            :on-exceed="showExceedMsg"
            :data="computedPlatformIds"
            >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传EXCEL文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="所属渠道" size="medium" prop="platformIds">
          <el-select v-model="importForm.platformIds" multiple style="width:90%;">
              <el-option
                v-for="item in platforms"
                :key="item.id"
                :label="item.name"
                :value="item.tag"
              ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="解禁时间" size="medium" prop="unbanTime">
            <el-date-picker
              v-model="importForm.unbanTime"
              type="datetime"
              placeholder="选择解禁时间"
              prefix-icon="aaa"
              style="width:90%;"
              :picker-options="pickerDisabled"
              >
            </el-date-picker>
        </el-form-item>
        <el-form-item class="text-left" label="封禁原因" prop="banMessage">
          <el-input type="textarea" maxlength="200" rows=4 style="width:90%;" v-model="importForm.banMessage"  placeholder="请输入封禁原因"></el-input>
        </el-form-item>
      </el-form>
      <el-row slot="footer" type="flex" justify="center" style="margin-top: -20px">
        <a href="./home/files/blacklistTemplate.xlsx"><el-button size="medium" type="success">模板下载</el-button></a>
        <el-button size="medium" style="margin-left: 30px;" @click="closeImportItemDialog">取 消</el-button>
        <el-button type="primary" size="medium" @click="importNewItem">确 定</el-button>
      </el-row>
    </el-dialog>
    <Progress progressTitle="导入黑名单" :progressTaskId="importProgressTaskId" ref="importProgress" :progressFinish="importFinish"></Progress>
    <Progress progressTitle="导出黑名单" :progressTaskId="exportProgressTaskId" ref="exportProgress" :progressFinish="exportFinish"></Progress>
  </div>
</template>
<script>
import { getDimensions, deleteItem, batchDeleteItems, addBlacklistItem, listBlacklistItem, listCreator, exportBlacklistItem, downExcelFile } from '@/api/user'
import Progress from '@/views/components/progress/Progress.vue'
import fileDownload from 'js-file-download'
export default {
  name: 'Blacklist',
  components: {
    Progress
  },
  data() {
    return {
      uploadAddr: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_BP_SERVICE') + '/customBlacklist/importItems',
      pickerDisabled: {
        disabledDate: (time) => {
          return time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
        }
      },
      form: {
        visitorId: '',
        platformIds: [],
        unbanTime: '',
        banMessage: ''
      },
      importForm: {
        platformIds: [],
        unbanTime: '',
        banMessage: ''
      },
      importProgressTaskId: 'import-blacklist',
      exportProgressTaskId: 'export-blacklist',
      platforms: [],
      creators: [],
      creatorIds: [],
      // 分页参数
      pageNum: 1,
      pageSize: 10,
      total: 0,
      // 工具栏
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      // 筛选条件
      startAndEndTime: [],
      selectPlatformIdList: [],
      searchText: '',
      // 1.表格内数据
      tableData: [],
      addItemDialog: false,
      importItemDialog: false,
      multipleUpload: false
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    headers() {
      return {
        'X-TENANT-ID': localStorage.getItem('X-TENANT-ID'),
        Authorization: localStorage.getItem('Authorization')
      }
    },
    computedPlatformIds() {
      return {
        platformIds: this.importForm.platformIds,
        unbanTime: this.importForm.unbanTime,
        banMessage: this.importForm.banMessage,
        progressTaskId: this.importProgressTaskId
      }
    }
  },
  methods: {
    importFinish(data) {
      this.$message.success(data.message)
      this.closeImportItemDialogAndClearForm()
      this._listBlacklistItem()
    },
    // 上传检查
    beforeUpload(img) {
      const isLt10M = img.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过10MB!')
      }
      return isLt10M
    },
    showExceedMsg() {
      this.$message.warning('超过文件个数限制')
    },
    init() {
      this._getDimensions()
      this._listCreator()
      this._listBlacklistItem()
    },
    searchBlackList() {
      this._listBlacklistItem()
    },
    // 分页栏点击事件
    handleCurrentChange(val) {
      this.pageNum = val
      this._listBlacklistItem()
    },
    genParam(type) {
      let startTime
      let endTime
      if (this.startAndEndTime && this.startAndEndTime.length === 2) {
        startTime = this.startAndEndTime[0]
        endTime = this.startAndEndTime[1]
      }
      if (type === 0) {
        return {
          startTime,
          endTime,
          searchText: this.searchText,
          creator: this.creatorIds,
          platformIds: this.selectPlatformIdList,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      } else if (type === 1) {
        return {
          startTime,
          endTime,
          searchText: this.searchText,
          creator: this.creatorIds,
          platformIds: this.selectPlatformIdList,
          progressId: this.exportProgressTaskId
        }
      }
    },
    // 查询
    _listBlacklistItem() {
      listBlacklistItem(this.genParam(0)).then(
        res => {
          if (res.code === 2000) {
            this.tableData = res.data.list
            this.total = res.data.total
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    // 新增黑名单
    addNewItem() {
      addBlacklistItem({
        visitorId: this.form.visitorId,
        platformIds: this.form.platformIds,
        unbanTime: this.form.unbanTime,
        banMessage: this.form.banMessage
      }).then(
        res => {
          if (res.code === 2000) {
            this.init()
          } else {
            this.$message.error(res.msg)
          }
        }
      )
      this.closeAddItemDialogAndClear()
    },
    // 查询所有操作人
    _listCreator() {
      listCreator({
      }).then(
        res => {
          if (res.code === 2000) {
            this.creators = res.data
          } else {
            this.$message.error(res.msg)
          }
        }
      )
      this.closeAddItemDialogAndClear()
    },
    clearForm() {
      this.form.visitorId = ''
      this.form.platformIds = []
      this.form.unbanTime = ''
      this.form.banMessage = ''
    },
    showAddItemDialog() {
      this.addItemDialog = true
    },
    // 确定导入
    importNewItem() {
      this.$refs.excelUploader.submit()
      this.$refs.importProgress.startProgress()
    },
    // 导入
    showImportItemDialog() {
      this.importItemDialog = true
    },
    // 关闭导入会话框
    closeImportItemDialog() {
      this.importItemDialog = false
    },
    closeImportItemDialogAndClearForm() {
      this.closeImportItemDialog()
      this.clearImportForm()
    },
    clearImportForm() {
      this.importForm.platformIds = []
      this.importForm.unbanTime = ''
      this.importForm.banMessage = ''
      this.$refs.excelUploader.clearFiles()
    },
    // 导出
    exportList() {
      exportBlacklistItem(this.genParam(1)).then(
        res => {
          if (res.code === 2000) {
            this.$refs.exportProgress.startProgress()
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    exportFinish(data) {
      downExcelFile({ excelName: data.fileName }).then(res => {
        fileDownload(res, data.fileName)
      })
    },
    // 批量删除
    batchDelete() {
      const selected = this.$refs.blacklistDataTable.selection
      if (!selected || selected.length === 0) {
        this.$message.error('请先勾选黑名单')
        return
      }
      this.$confirm('黑名单删除后将无法恢复，请您确认是否需要删除？', '', {
        confirmButtonText: '确 认',
        cancelButtonText: '取 消',
        type: 'warning',
        showClose: false
      })
        .then(() => {
          batchDeleteItems({
            items: selected
          }).then(
            res => {
              if (res.code === 2000) {
                this.$message.success('删除成功')
                this.init()
              } else {
                this.$message.error(res.msg)
              }
            }
          )
        })
        .catch(() => {})
    },
    closeAddItemDialog() {
      this.addItemDialog = false
    },
    closeAddItemDialogAndClear() {
      this.closeAddItemDialog()
      this.clearForm()
    },
    _getDimensions() {
      getDimensions({
        detail: true
      }).then(
        res => {
          if (res.code === 2000) {
            this.platforms = res.data
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    _deleteItem(row) {
      const blacklistItemId = row.id
      this.$confirm('黑名单删除后将无法恢复，请您确认是否需要删除？', '', {
        confirmButtonText: '确 认',
        cancelButtonText: '取 消',
        type: 'warning',
        showClose: false
      })
        .then(() => {
          deleteItem({
            id: blacklistItemId
          }).then(
            res => {
              if (res.code === 2000) {
                this.$message.success('删除成功')
                this.init()
              } else {
                this.$message.error(res.msg)
              }
            }
          )
        })
        .catch(() => {})
    },
    showChatHistory(row) {
      this.$store.commit('user/setBlPageIndex', { blPageIndex: 2 })
      this.$store.commit('user/setChatHistoryQuery', {
        chatHistoryQuery: {
          sessionId: row.sessionId
        }
      })
    }
  }
}
</script>
<style lang="scss">
 .table-tool{margin:10px 0 4px;}
</style>
<style lang="scss" scoped>
  .wrapper {
    height: 100%;
  }
  .scrollbar-wrap {
    height: calc(100% - 61px - 78px);
  }
</style>
